import jwtDecode from 'jwt-decode'
import IToken from '@/model/token'
import http from '@/plugins/axios'
import CacheStore from '@/store/cache-store'

export default class AuthService {
  public static LOGOUT = `${process.env.VUE_APP_BASE_API_URL}api/Saml/InitiateLogout?returnurl=${process.env.VUE_APP_BASE_CLIENT_URL}`

  public getToken () {
    const token = CacheStore.getFromSession(CacheStore.TOKEN)
    if (token) {
      return token
    }
    return ''
  }

  public logout () {
    http.post(AuthService.LOGOUT)
  }

  public getDecodedToken (): IToken {
    const decodedToken = jwtDecode(this.getToken()) as IToken
    return decodedToken
  }

  public isAuthenticated () {
    const token = this.getToken()
    if (token) {
      return true
    }

    return false
  }
}
